module.exports = __webpack_public_path__ + "img/img-tradecashback-sec-03-01.png";